import { I18n } from 'react-redux-i18n';

const inviteTypes = {
  0: I18n.t('Assessment'),
  1: I18n.t('360 Appraisal'),
  2: I18n.t('360 Appraisal'),
};

export default inviteTypes;
